<template>
  <b-card class="border-0 shadow-none card-secondary">
    <h5 class="mb-3">{{ trans("courses.new_dashboard.progress") }}</h5>

    <div class="d-flex justify-content-center">
      <radial-progress :diameter="125" :completed-steps="progress" :total-steps="100">
        <div v-if="completedModules === 0">
          <b-icon-geo-alt :font-scale="2.5" variant="primary" class="pin-icon" />
        </div>
        <div v-else class="h4 mb-0">{{ displayValue }}</div>
      </radial-progress>
    </div>
    <small class="text-center mt-2">{{ progressLabel }}</small>
    <slot />
  </b-card>
</template>

<script>
import navMixin from "../mixins/navMixin";
import RadialProgress from "../molecules/RadialProgress";

export default {
  name: "UsersProgress",
  components: { RadialProgress },
  mixins: [navMixin],
  props: {
    allModules: Number,
    completedModules: Number,
    displayValue: String,
    progressLabel: String,
    progress: Number,
  },
};
</script>

<style scoped lang="scss">
.progress {
  @include border-radius(0.375rem);
}

.icon-wrapper {
  img {
    width: 20px;
    margin: 0 $spacer ($spacer / 2) 0;
  }
}

.pin-icon {
  opacity: 0.4;
}
</style>
